import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import APLoadingProgress from "./../../atoms/APLoadingProgress";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            background: "#f5f5f5",
            color: "#4a4a4a",
            width: "auto",
            padding: 15,
            fontSize: 15,
            borderRadius: 4,
            "& p": {
                margin: 0
            }
        },
        loadingProgress: {
            width: 180
        }
    })
);

export default function APLoadingBar(props: any) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <p>{props.fileName.toLowerCase()}</p>
            <APLoadingProgress fileSize={props.fileSize} uploaded={props.uploaded}/>
        </div>
    );
}